import txLogo from './assets/images/txLogo.png';
import laLogo from './assets/images/laLogo.png';
import arLogo from './assets/images/ARLogo.gif';
import msLogo from './assets/images/MSLogo.png';
import nyLogo from './assets/images/NYLogo.png';
import okLogo from './assets/images/OKLogo.gif';
import ohLogo from './assets/images/ohLogo.png';

const currentYear = new Date().getFullYear();

const stateConfig = {
  la: {
    website: 'https://www.legiscon.com/',
    logo: laLogo,
    bannerBlue: true,
    icon: '/icons/lafavicon.ico',
    tabTitle: 'Legiscon - AI',
    footer: `Copyright © ${currentYear}, LEGISCON, All Rights Reserved.`,
  },
  tx: {
    website: 'https://www.telicon.com/',
    logo: txLogo,
    bannerBlue: true,
    icon: '/icons/txfavicon.ico',
    tabTitle: 'Telicon - AI',
    footer: `Copyright © ${currentYear}, TELICON, All Rights Reserved.`,
  },
  ny: {
    website: 'https://nystatewatch.net/',
    logo: nyLogo,
    bannerBlue: true,
    icon: '/icons/msfavicon.ico',
    tabTitle: 'NY StateWatch - AI',
    footer: `Copyright © ${currentYear}, NYStateWatch, All Rights Reserved.`,
  },
  ok: {
    website: 'https://legisok.com/',
    logo: okLogo,
    bannerBlue: false,
    icon: '/icons/okfavicon.ico',
    tabTitle: 'LegisOk - AI',
    footer: `Copyright © ${currentYear} LegisOK. All rights reserved.`,
  },
  ms: {
    website: 'https://msstatewatch.net/',
    logo: msLogo,
    bannerBlue: true,
    icon: '/icons/msfavicon.ico',
    tabTitle: 'MS StateWatch - AI',
    footer: `Copyright © ${currentYear} MS StateWatch. All rights reserved.`,
  },
  ar: {
    website: 'https://ardigest.net/',
    logo: arLogo,
    bannerBlue: false,
    icon: '/icons/msfavicon.ico',
    tabTitle: 'AR Digest - AI',
    footer: `Copyright © ${currentYear} AR Digest. All rights reserved.`,
  },
  oh: {
    website: 'https://www.legislature.ohio.gov/',
    logo: ohLogo,
    bannerBlue: true,
    icon: '/icons/liqfavicon.ico',
    tabTitle: 'LegisIQ - AI',
    defaultVersion: 'FH00',
    footer: '',
  },
  il: {
    website: 'https://www.legislature.ohio.gov/',
    logo: ohLogo,
    bannerBlue: true,
    icon: '/icons/liqfavicon.ico',
    tabTitle: 'LegisIQ - AI',
    defaultVersion: 'INT',
    footer: '',
  },
};

export default stateConfig;
